import { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import api from '../../../utils/api'
import SelectStyles from '../../../shared/Select/SelectStyle'
import Input from '../../../shared/components/form/input'
import Button from '../../../shared/components/Button/Button'

function ServiceOrderConcludedFilterModal({ filters, onChange, onClear, onClose, serviceOrders }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [clientOptions, setClientOptions] = useState([])
    const [technicianOptions, setTechnicianOptions] = useState([])

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    useEffect(() => {
        const headers = { Authorization: `Bearer ${JSON.parse(token)}` }
        Promise.all([
            api.get('/client/getall', { headers }),
            api.get('/user/technicians', { headers }),
        ]).then(([clientRes, techRes]) => {
            setClientOptions(clientRes.data.clients || [])
            setTechnicianOptions((techRes.data.technicians || []).map(t => ({
                ...t,
                label: t.name,
                value: t._id,
            })))
        })
    }, [token])

    const generatorOptions = useMemo(() => {
        const map = new Map()
        ;(serviceOrders || []).forEach((order) => {
            const generator = order.generator
            const id = generator?._id || generator?.value
            if (generator?.label && id && !map.has(id)) {
                map.set(id, { ...generator, value: id })
            }
        })
        return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label))
    }, [serviceOrders])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar OS concluídas</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Cliente</span>
                        <Select
                            options={clientOptions}
                            onChange={(opt) => onChange('client', opt)}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={filters.client || null}
                            placeholder="Todos os clientes"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Gerador</span>
                        <Select
                            options={generatorOptions}
                            onChange={(opt) => onChange('generator', opt)}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={filters.generator || null}
                            placeholder="Todos os geradores"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Técnico</span>
                        <Select
                            options={technicianOptions}
                            onChange={(opt) => onChange('technician', opt)}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={filters.technician || null}
                            placeholder="Todos os técnicos"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Período agendado</span>
                        <div className="so-filter-date-row">
                            <div className="so-filter-date-col">
                                <Input
                                    type="date"
                                    name="dateFrom"
                                    text="De"
                                    value={filters.dateFrom || ''}
                                    handleOnChange={(e) => onChange('dateFrom', e.target.value)}
                                />
                            </div>
                            <div className="so-filter-date-col">
                                <Input
                                    type="date"
                                    name="dateTo"
                                    text="Até"
                                    value={filters.dateTo || ''}
                                    handleOnChange={(e) => onChange('dateTo', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ServiceOrderConcludedFilterModal
